import { render, staticRenderFns } from "./BoxList.vue?vue&type=template&id=49db1c9c&scoped=true"
import script from "./BoxList.vue?vue&type=script&lang=js"
export * from "./BoxList.vue?vue&type=script&lang=js"
import style0 from "./BoxList.vue?vue&type=style&index=0&id=49db1c9c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49db1c9c",
  null
  
)

export default component.exports